<template>
  <v-col>
    <v-row justify="center" justify-md="start" class="ma-0 mt-2">
      <v-col cols="12" md="6">
        <v-row justify="center" justify-md="start" class="mb-4">
          <v-icon
            color="#4390c0"
            @click="
                        $emit('close');
                    "
          >mdi-arrow-left-circle</v-icon>
          <h4 class="grey-color mx-4" style="font-weight: 500" v-if="!user">Add Client</h4>
          <h4 class="grey-color mx-4" style="font-weight: 500" v-if="user">View Client</h4>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-row justify="center" justify-md="end">
          <v-select
            v-if="user && loggedInUser.userType == 'Admin' &&
                        loggedInUser.adminType == 'Super Admin'"
            @change="setUserStatus"
            class="statusSelect"
            dense
            outlined
            filled
            style="max-width: 200px"
            :items="statusOptions"
            v-model="originalUser.status"
          ></v-select>
        </v-row>
      </v-col>
    </v-row>
    <v-card class="white-card pa-8 relative">
      <v-chip
        v-if="user"
        class="email-verified-chip"
        :color="emailVerified ? 'green' : '#e67e22'"
        dark
      >
        <v-icon left small>{{
          emailVerified ? "mdi-email-check" : "mdi-email-alert"
        }}</v-icon>
        {{ emailVerified ? "Email verified" : "Email not verified" }}
      </v-chip>
      <v-tabs v-model="tabs">
        <v-tab>Account Information</v-tab>
        <v-tab @click="highestTabActive = 1">Medical Information</v-tab>
      </v-tabs>
      <v-row justify="center" class="ma-0">
        <v-row v-if="user" class="ma-0 mt-4" justify="center">
          <div class="avatar-upload">
            <label for="avatar-input" class="avatar-label">
              <div v-if="newUser && newUser.profilePhoto" class="avatar-preview">
                <img :src="newUser.profilePhoto.url" alt="Preview" />
              </div>
              <div v-else class="avatar-placeholder">Tap to upload or take a selfie</div>
            </label>
            <input
              id="avatar-input"
              type="file"
              accept="image/*"
              capture="user"
              @change="onFileChange"
              style="display: none"
            />
          </div>
        </v-row>
      </v-row>
      <v-tabs-items v-model="tabs">
        <v-tab-item class="pt-6">
          <v-card flat class="account-details w-100 my-5">
            <v-form ref="userForm">
              <v-row justify="center" justify-md="start">
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.firstName"
                      label="Name"
                      required
                      :rules="letterRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.lastName"
                      required
                      :rules="letterRules"
                      label="Surname"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.email"
                      label="Email Address"
                      required
                      :rules="emailRules"
                      :readonly="user"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col v-if="user" cols="12" md="6">
                  <v-switch
                    :key="emailSwitchKey"
                    class="mt-0"
                    :input-value="emailVerified"
                    inset
                    color="green"
                    :label="
                      emailVerified ? 'Email verified' : 'Email not verified'
                    "
                    hide-details
                    :disabled="updatingEmailVerified"
                    @change="requestEmailVerification"
                  ></v-switch>
                </v-col>
                <v-col v-if="!user" cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.password"
                      label="Password"
                      required
                      :rules="passwordRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col v-if="!user" cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.confirmPassword"
                      label="Confirm Password"
                      required
                      :rules="passwordRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.contact"
                      label="Phone Number"
                      required
                      :rules="contactRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-textarea
                      dense
                      filled
                      outlined
                      v-model="newUser.address"
                      label="Address"
                      required
                      :rules="nullRules"
                    ></v-textarea>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.nextOfKin.firstName"
                      label="Next of Kin Name"
                      required
                      :rules="letterRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.nextOfKin.lastName"
                      label="Next of Kin Surname"
                      required
                      :rules="letterRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.nextOfKin.email"
                      label="Next of Kin Email"
                      required
                      :rules="emailRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.nextOfKin.phone"
                      label="Next of Kin Phone Number"
                      required
                      :rules="contactRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.nextOfKin.idNumber"
                      label="Next of Kin ID Number"
                      required
                      :rules="idNumberRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.walletBalance"
                      label="Wallet Balance(R)"
                      required
                      readonly="true"
                    ></v-text-field>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
            <v-row justify="center">
              <v-col cols="12" md="6">
                <span class="label">Dependants:</span>

                <h4
                  v-if="!newUser.dependants || !newUser.dependants[0]"
                  class="pink-color mt-4"
                >No dependants yet...</h4>

                <v-row
                  v-for="(currentDependant, index) in newUser.dependants"
                  :key="currentDependant"
                  justify="start"
                  class="ma-0 mt-4"
                >
                  <v-col cols="auto" class="pa-0">
                    <v-row justify="start" class="ma-0">
                      <h4
                        class="blue-color"
                      >{{ currentDependant.firstName + " " + currentDependant.lastName }}</h4>
                    </v-row>
                  </v-col>
                  <v-col cols="auto" class="pa-0 px-2">
                    <v-row justify="end" class="ma-0">
                      <v-icon
                        class="pink-color"
                        @click="
                                                editIndex = index;
                                            openDependant(currentDependant);
                                            "
                      >mdi-pencil</v-icon>
                      <v-icon
                        class="pink-color"
                        @click="
                                                selectedDependant = currentDependant;
                                            deleteType = 'dependant';
                                            deleteDialog = true;
                                            "
                      >mdi-delete</v-icon>
                    </v-row>
                  </v-col>
                </v-row>

                <v-btn
                  width="240px"
                  dark
                  rounded
                  outlined
                  class="blue-btn my-6"
                  @click="openNewDependant()"
                >Add a dependant</v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-row class="ma-0">
                  <span class="label">Pets:</span>
                </v-row>

                <h4 v-if="!newUser.pets || !newUser.pets[0]" class="pink-color mt-4">No pets yet...</h4>

                <v-row
                  v-for="(currentPet, index) in newUser.pets"
                  :key="currentPet"
                  justify="start"
                  class="ma-0 mt-4"
                >
                  <v-col cols="auto" class="pa-0">
                    <v-row justify="start" class="ma-0">
                      <h4 class="blue-color">{{ currentPet.name }}</h4>
                    </v-row>
                  </v-col>
                  <v-col cols="auto" class="pa-0 px-2">
                    <v-row justify="end" class="ma-0">
                      <v-icon
                        class="pink-color"
                        @click="
                                                editIndex = index;
                                            openPet(currentPet);
                                            "
                      >mdi-pencil</v-icon>
                      <v-icon
                        class="pink-color"
                        @click="
                                                selectedPet = currentPet;
                                            deleteType = 'pet';
                                            deleteDialog = true;
                                            "
                      >mdi-delete</v-icon>
                    </v-row>
                  </v-col>
                </v-row>

                <v-btn
                  width="240px"
                  dark
                  rounded
                  outlined
                  class="blue-btn mt-6"
                  @click="openNewPet()"
                >Add a pet</v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item class="pt-6">
          <v-card flat class="account-details w-100 mb-5">
            <v-form ref="medicalForm">
              <v-row justify="center" justify-md="start">
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.medicalAidName"
                      label="Medical Aid Name"
                      required
                      :rules="letterRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.medicalAidNo"
                      label="Medical Aid No"
                      required
                      :rules="numberRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.optionName"
                      label="Option Name"
                      required
                      :rules="letterRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.bloodType"
                      label="Blood Type"
                      required
                      :rules="nullRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.dateOfBirth"
                      label="Date of Birth"
                      required
                      :rules="dateRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.height"
                      label="Height"
                      required
                      :rules="nullRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.weight"
                      label="Weight"
                      required
                      :rules="numberRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.allergies"
                      label="Allergies"
                      required
                      :rules="letterRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.medication"
                      label="Medication you are on"
                      required
                      :rules="nullRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="12" md="6">
                  <v-row class="ma-0">
                    <v-text-field
                      dense
                      filled
                      outlined
                      v-model="newUser.medicalConditions"
                      label="Medical Conditions"
                      required
                      :rules="letterRules"
                    ></v-text-field>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-row justify="center" justify-md="start" class="ma-0 mb-4">
      <v-btn
        v-if="!user"
        @click="addUser()"
        color="#e022d1"
        dark
        rounded
        width="240px"
        class="pink-btn mt-4"
      >Add User</v-btn>
      <v-btn
        @click="updateUser()"
        v-if="user"
        color="#e022d1"
        dark
        rounded
        width="240px"
        class="pink-btn mt-4"
      >Update User</v-btn>
      <v-btn
        @click="refundDialog = true"
        v-if="user"
        color="#4390c0"
        dark
        rounded
        width="240px"
        class="blue-btn mt-4 mx-2"
      >Refund User</v-btn>
    </v-row>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">mdi-alert-circle</v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">mdi-check-circle</v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
          >CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="emailVerifyDialog" max-width="480" persistent>
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" :color="pendingEmailVerified ? 'green' : '#e67e22'">
            {{ pendingEmailVerified ? "mdi-email-check" : "mdi-email-alert" }}
          </v-icon>
          <div class="body-1 text-h6 mt-6">
            Are you sure you want to mark
            {{ (newUser && newUser.email) || "this account" }} as
            {{ pendingEmailVerified ? "verified" : "not verified" }}?
          </div>
        </v-card-text>
        <v-row justify="center" class="mt-6">
          <v-btn
            color="black"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            :disabled="updatingEmailVerified"
            @click="cancelEmailVerification"
            >CANCEL</v-btn
          >
          <v-btn
            color="blue"
            dark
            depressed
            large
            class="mx-2"
            style="border-radius: 24px"
            :loading="updatingEmailVerified"
            @click="applyEmailVerification"
            >CONFIRM</v-btn
          >
        </v-row>
      </v-card>
    </v-dialog>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate></v-progress-circular>
      </v-overlay>
    </v-row>
    <v-dialog width="350px" v-model="dependantDialog">
      <div class="register-card">
        <div class="steps">
          <div
            v-for="n in 2"
            :key="n"
            class="step"
            :class="{ 'step--active': currentStepDependants === n }"
            :style="{
                            background:
                                currentStepDependants === n
                                    ? n === 2
                                        ? '#FF00FF'
                                        : '#556B2F'
                                    : '#E0E0E0',
                        }"
          ></div>
        </div>

        <template v-if="currentStepDependants === 1">
          <h3 class="title">Dependant is a</h3>

          <v-btn
            block
            large
            rounded
            class="option-btn"
            :class="{ selected: dependant.gender == 'man' }"
            @click="selectGender('man')"
          >Man</v-btn>
          <v-btn
            block
            large
            rounded
            class="option-btn"
            :class="{ selected: dependant.gender == 'woman' }"
            @click="selectGender('woman')"
          >Woman</v-btn>

          <v-btn
            block
            large
            rounded
            variant="outlined"
            class="continue-btn--outlined mt-8"
            @click="nextStepDependants"
          >Continue</v-btn>
          <v-btn block large rounded text variant="flat" @click="dependantDialog = false">Cancel</v-btn>
        </template>
        <template v-else-if="currentStepDependants === 2">
          <h3 class="title">DEPENDANT DETAILS</h3>

          <v-form
            ref="medicalFormDependant"
            class="py-4"
            style="max-height: 50vh; overflow-y: scroll"
          >
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.firstName"
              label="First name"
              class="field"
              required
              :rules="letterRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.lastName"
              label="Last name"
              class="field"
              required
              :rules="letterRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.medicalAidName"
              label="Medical Aid Name"
              class="field"
              required
              :rules="letterRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.medicalAidNo"
              label="Medical Aid No."
              class="field"
              required
              :rules="numberRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.optionName"
              label="Option Name"
              class="field"
              required
              :rules="letterRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.dateOfBirth"
              label="Date of Birth"
              class="field"
              required
              :rules="dateRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.height"
              label="Height"
              class="field"
              required
              :rules="nullRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.height"
              label="Height"
              class="field"
              required
              :rules="nullRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.weight"
              label="Weight"
              class="field"
              required
              :rules="numberRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.allergies"
              label="Allergies"
              class="field"
              required
              :rules="letterRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.medication"
              label="Medication you are on"
              class="field"
              required
              :rules="nullRules"
            />
            <v-text-field
              dense
              filled
              outlined
              v-model="dependant.medicalConditions"
              label="Medical Conditions"
              class="field"
              required
              :rules="letterRules"
            />
          </v-form>

          <!-- <div class="upload-row mt-6">
                        <span class="upload-label">Vaccination Card</span>
                        <v-btn class="upload-btn" @click="onUpload">Upload</v-btn>
                        <input type="file" ref="fileInput" class="d-none" @change="onFileChange" />
          </div>-->

          <v-btn
            v-if="!editingDependant"
            block
            large
            rounded
            class="continue-btn--outlined mt-8"
            @click="nextStepDependants()"
          >Add Dependant</v-btn>
          <v-btn
            v-if="editingDependant"
            block
            large
            rounded
            class="continue-btn--outlined mt-8"
            @click="nextStepDependants()"
          >Update Dependant</v-btn>
          <v-btn
            block
            large
            rounded
            text
            variant="flat"
            class="back-btn"
            @click="prevStepDependants()"
          >Back</v-btn>
        </template>
      </div>
    </v-dialog>
    <v-dialog width="350px" v-model="petDialog">
      <div class="register-card">
        <div class="steps">
          <div
            v-for="n in 2"
            :key="n"
            class="step"
            :class="{ 'step--active': currentStepPets === n }"
            :style="{
                        background:
                            currentStepPets === n
                                ? n === 2
                                    ? '#FF00FF'
                                    : '#556B2F'
                                : '#E0E0E0',
                    }"
          ></div>
        </div>

        <template v-if="currentStepPets === 1">
          <h3 class="title">Pet is a</h3>

          <v-btn
            block
            large
            rounded
            class="option-btn"
            :class="{ selected: pet.type === 'dog' }"
            @click="setType('dog')"
          >Dog</v-btn>

          <v-btn
            block
            large
            rounded
            class="option-btn"
            :class="{ selected: pet.type === 'cat' }"
            @click="setType('cat')"
          >Cat</v-btn>

          <v-btn
            block
            large
            rounded
            class="option-btn"
            :class="{ selected: pet.type === 'bird' }"
            @click="setType('bird')"
          >Bird</v-btn>

          <v-btn
            block
            large
            rounded
            class="option-btn"
            :class="{ selected: pet.type === 'reptile' }"
            @click="setType('reptile')"
          >Reptile</v-btn>

          <v-btn
            block
            large
            rounded
            variant="outlined"
            class="continue-btn--outlined mt-8"
            @click="nextStepPets"
          >Continue</v-btn>
          <v-btn block large rounded text variant="flat" @click="petDialog = false">Cancel</v-btn>
        </template>
        <template v-else-if="currentStepPets === 2">
          <h3 class="title">PET DETAILS</h3>

          <v-form ref="petsForm" class="py-4" style="max-height: 50vh; overflow-y: scroll">
            <v-text-field
              v-model="pet.name"
              label="Name"
              dense
              outlined
              filled
              class="field"
              required
              :rules="letterRules"
            />
            <v-text-field
              v-model="pet.breed"
              label="Breed"
              dense
              outlined
              filled
              class="field"
              required
              :rules="nullRules"
            />
            <v-text-field
              v-model="pet.age"
              label="Age"
              dense
              outlined
              filled
              class="field"
              required
              :rules="nullRules"
            />
            <v-text-field
              v-model="pet.insurance"
              label="Insurance"
              dense
              outlined
              filled
              class="field"
              required
              :rules="nullRules"
            />
            <v-text-field
              v-model="pet.conditions"
              label="Medical Conditions"
              dense
              outlined
              filled
              class="field"
              required
              :rules="nullRules"
            />
          </v-form>

          <!-- <div class="upload-row mt-6">
                        <span class="upload-label">Vaccination Card</span>
                        <v-btn class="upload-btn" @click="onUpload">Upload</v-btn>
                        <input type="file" ref="fileInput" class="d-none" @change="onFileChange" />
          </div>-->

          <v-btn
            v-if="!editingPet"
            block
            large
            rounded
            class="continue-btn--outlined mt-8"
            @click="nextStepPets()"
          >Add Pet</v-btn>
          <v-btn
            v-if="editingPet"
            block
            large
            rounded
            class="continue-btn--outlined mt-8"
            @click="nextStepPets()"
          >Update Pet</v-btn>
          <v-btn
            block
            large
            rounded
            text
            variant="flat"
            class="back-btn"
            @click="prevStepPets()"
          >Back</v-btn>
        </template>
      </div>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="#4390c0">mdi-check-circle</v-icon>
          <div class="body-1 text-h6">Are you sure you want to delete this {{ deleteType }}?</div>
        </v-card-text>
        <v-row justify="center">
          <v-btn
            color="#4390c0"
            dark
            depressed
            large
            rounded
            class="mx-2"
            @click="deleteDialog = false"
          >CLOSE</v-btn>
          <v-btn
            v-if="deleteType == 'dependant'"
            color="#e022d1"
            dark
            depressed
            large
            rounded
            class="mx-2"
            @click="deleteDependant()"
          >DELETE</v-btn>
          <v-btn
            v-if="deleteType == 'pet'"
            color="#e022d1"
            dark
            depressed
            large
            rounded
            class="mx-2"
            @click="deletePet()"
          >DELETE</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="refundDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="#4390c0">mdi-check-circle</v-icon>
          <div class="body-1 text-h6">How much would you like to refund this client?</div>
        </v-card-text>
        <v-row justify="center">
          <v-text-field
            v-model="refundAmount"
            label="Refund Amount"
            dense
            outlined
            filled
            class="field"
            required
            :rules="numberRules"
            ref="refund"
          />
        </v-row>
        <v-row justify="center">
          <v-btn
            color="#4390c0"
            dark
            depressed
            large
            rounded
            class="mx-2"
            @click="refundDialog = false"
          >Cancel</v-btn>
          <v-btn
            color="#e022d1"
            dark
            depressed
            large
            rounded
            class="mx-2"
            @click="refundUser()"
          >Refund</v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  setDoc,
  query,
  getDoc,
  doc,
  addDoc,
  deleteDoc,
  updateDoc
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig.js";
const db = getFirestore(firebaseApp);

import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject
} from "firebase/storage";
const storage = getStorage(firebaseApp);

import Vue from "vue";

import { logAction } from "@/utils/firestoreUtil";

export default {
  data() {
    return {
      newUser: null,
      idNumberRules: [
        v => !!v || "ID number is required",
        v => /^\d{13}$/.test(v) || "ID number must be exactly 13 digits"
      ],
      emailRules: [
        v => !!v || "Email is required",
        v => /.+@.+\..+/.test(v) || "Email must be valid"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 6) || "Password must be at least 6 characters",
        v =>
          /(?=.*[A-Z])/.test(v) ||
          "Password must contain at least one uppercase letter",
        v =>
          /(?=.*[a-z])/.test(v) ||
          "Password must contain at least one lowercase letter",
        v =>
          /(?=.*[0-9])/.test(v) || "Password must contain at least one number",
        v =>
          /(?=.*[!@#+*\$%\^&])/.test(v) ||
          "Password must contain at least one special character"
      ],
      nullRules: [v => !!v || "Field is required"],
      contactRules: [
        v => !!v || "Contact is required",
        v => /^\d{10}$/.test(v) || "Contact must be valid number with 10 digits"
      ],
      numberRules: [
        v => !!v || "Field is required",
        v => /^\d+$/.test(v) || "Field must be numbers only"
      ],
      letterRules: [
        v => !!v || "Field is required",
        v =>
          /^[A-Za-z\s]+$/.test(v) ||
          "Field must only contain letters and spaces"
      ],
      dateRules: [
        v => !!v || "Field is required",
        v =>
          /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/.test(v) ||
          "Date must be in format YYYY-MM-DD"
      ],
      loading: false,
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      emailVerifyDialog: false,
      pendingEmailVerified: null,
      updatingEmailVerified: false,
      emailSwitchKey: 0,
      selectedTab: "account",
      pets: [],
      dependants: [],
      dependantDialog: false,
      petDialog: false,
      currentStepDependants: 1,
      currentStepPets: 1,
      dependant: {},
      pet: {},
      editingDependant: false,
      editingPet: false,
      editIndex: 0,
      deleteDialog: false,
      deleteType: "",
      selectedDependant: null,
      selectedPet: null,
      tabs: 0,
      highestTabActive: 0,
      statusOptions: ["pending", "on hold", "approved", "denied"],
      originalUser: null,
      refundAmount: 0,
      refundDialog: false
    };
  },
  props: {
    user: null
  },
  created() {
    this.highestTabActive = 0;
    this.newUser = this.user;

    console.log("User: ", this.user);

    if (!this.newUser) {
      this.newUser = {};
    } else {
      this.originalUser = Object.assign({}, this.user);
      localStorage.setItem("ViewedUser", JSON.stringify(this.newUser));
    }

    if (!this.newUser.nextOfKin) {
      this.newUser.nextOfKin = {};
    }

    if (!this.newUser.walletBalance) {
      this.newUser.walletBalance = 0;
    }

    console.log("User: ", this.newUser);
  },
  methods: {
    selectGender(gender) {
      this.dependant.gender = gender;
      this.$forceUpdate();
    },
    setType(type) {
      this.pet.type = type;
      this.$forceUpdate();
    },
    async onFileChange(event) {
      if (this.readOnly) {
        return;
      }

      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        this.file = file;

        const newRef = ref(
          storage,
          "Doctors/" + this.newUser.id + "/Documents/" + "ProfilePhoto" + ".png"
        );

        try {
          this.loading = true;
          const snapshot = await uploadBytes(newRef, file);
          const url = await getDownloadURL(newRef);

          if (!this.newUser.profilePhoto) {
            this.newUser.profilePhoto = {};
          }

          this.newUser.profilePhoto.url = url;
          this.newUser.profilePhoto.ref = newRef.fullPath;

          this.loading = false;

          this.updateUser();
        } catch (error) {
          this.loading = false;
          console.log("error: ", false);
          this.promptMessage =
            "An error occured while uploading the profile photo, please try again!";
          this.promptType = "error";
          this.promptDialog = true;
        }
      } else {
        this.promptMessage = "Please select an image!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async createUserAuth() {
      let body = JSON.stringify({
        data: {
          email: this.newUser.email,
          password: this.password
        }
      });

      this.loading = true;

      let authRes;

      try {
        authRes = await fetch(
          "https://createauthuser-4woel4f54a-uc.a.run.app",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: body
          }
        );

        this.loading = false;

        if (authRes.ok) {
          const responseBody = await authRes.json();

          console.log("Res: ", responseBody.result);

          if (responseBody.result.success) {
            return {
              success: responseBody.result.success
            };
          } else if (responseBody.result.error) {
            return {
              error: responseBody.result.error
            };
          }
        }
      } catch (error) {
        this.loading = false;
        console.log("Res: ", error);
        return {
          error: error
        };
      }
    },
    async addUser() {
      let valid = this.$refs.userForm.validate();

      if (!valid) {
        this.promptMessage = "Please fill out all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      valid = this.$refs.medicalForm.validate();

      if (!valid) {
        this.promptMessage = "Please fill out all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      let res = await this.createUserAuth();

      if (res.success) {
        console.log("Success: ", res.success);
        this.newUser.authID = res.success;
      } else if (res.error) {
        this.promptMessage = res.error;
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      try {
        Vue.delete(this.newUser, "password");
        Vue.delete(this.newUser, "confirmPassword");

        this.loading = true;
        const docRef = await addDoc(collection(db, "clients"), this.newUser);
        this.loading = false;

        let res = await logAction(
          "User Management",
          "Account Created",
          this.loggedInUser.email,
          this.loggedInUser.email +
            " has created a new client account(" +
            this.newUser.email +
            ")"
        );

        this.promptMessage = "Successfully created account!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.$router.go();
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log(error);

        this.promptMessage =
          "An error occured while starting the consultation, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async updateUser() {
      let valid = this.$refs.userForm.validate();

      if (!valid) {
        this.promptMessage = "Please fill out all required fields!";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      if (this.highestTabActive == 1) {
        valid = this.$refs.medicalForm.validate();

        if (!valid) {
          this.promptMessage = "Please fill out all required fields!";
          this.promptType = "error";
          this.promptDialog = true;
          return;
        }
      }

      try {
        this.loading = true;
        const docRef = await setDoc(
          doc(db, "clients", this.newUser.id),
          this.newUser
        );
        this.loading = false;

        let res = await logAction(
          "User Management",
          "Account Updated",
          this.loggedInUser.email,
          this.loggedInUser.email +
            " has updated client account " +
            this.newUser.email
        );

        this.promptMessage = "Successfully updated account!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.$router.go();
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log(error);

        this.promptMessage =
          "An error occured while starting the consultation, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async nextStepDependants() {
      if (this.currentStepDependants < 3) {
        if (this.currentStepDependants == 1) {
          if (this.dependant.gender) {
            this.currentStepDependants++;
          } else {
            this.promptType = "error";
            this.promptMessage = "Please select a gender!";
            this.promptDialog = true;
          }
        } else if (this.currentStepDependants == 2) {
          let valid = this.$refs.medicalFormDependant.validate();

          if (valid) {
            this.dependantDialog = false;

            if (this.editingDependant == false) {
              this.addDependant();
            } else {
              this.updateDependant();
            }
          } else {
            this.promptType = "error";
            this.promptMessage = "Please fill out all required fields!";
            this.promptDialog = true;
          }
        }
      }
    },
    prevStepDependants() {
      if (this.currentStepDependants > 1) this.currentStepDependants--;
    },
    async nextStepPets() {
      if (this.currentStepPets < 3) {
        if (this.currentStepPets == 1) {
          if (this.pet.type) {
            this.currentStepPets++;
          } else {
            this.promptType = "error";
            this.promptMessage = "Please select a type!";
            this.promptDialog = true;
          }
        } else if (this.currentStepPets == 2) {
          let valid = this.$refs.petsForm.validate();

          if (valid) {
            this.petDialog = false;

            if (this.editingPet == false) {
              this.addPet();
            } else {
              this.updatePet();
            }
          } else {
            this.promptType = "error";
            this.promptMessage = "Please fill out all required fields!";
            this.promptDialog = true;
          }
        }
      }
    },
    prevStepPets() {
      if (this.currentStepPets > 1) this.currentStepPets--;
    },
    addDependant() {
      if (!this.newUser.dependants) {
        this.newUser.dependants = [];
      }

      this.newUser.dependants.push(this.dependant);
      this.newUser.dependant = {};
      // localStorage.setItem("dependants", JSON.stringify(this.user.dependants));
    },
    updateDependant() {
      this.newUser.dependants[this.editIndex] = this.dependant;
      // localStorage.setItem("dependants", JSON.stringify(this.user.dependants));
    },
    openNewDependant() {
      this.currentStepDependants = 1;
      this.dependant = {};
      this.editingDependant = false;
      this.dependantDialog = true;
    },
    openDependant(dependant) {
      this.currentStepDependants = 1;
      this.editingDependant = true;
      this.dependant = dependant;
      this.dependantDialog = true;
    },
    deleteDependant() {
      this.deleteDialog = false;
      this.newUser.dependants.splice(
        this.newUser.dependants.indexOf(this.selectedDependant),
        1
      );
      // localStorage.setItem("dependants", JSON.stringify(this.dependants));
    },
    addPet() {
      if (!this.newUser.pets) {
        this.newUser.pets = [];
      }

      this.newUser.pets.push(this.pet);
      this.pet = {};
      // localStorage.setItem("pets", JSON.stringify(this.pets));
    },
    updatePet() {
      this.newUser.pets[this.editIndex] = this.pet;
      // localStorage.setItem("pets", JSON.stringify(this.pets));
    },
    openNewPet() {
      this.currentStepPets = 1;
      this.pet = {};
      this.editingPet = false;
      this.petDialog = true;
    },
    openPet(pet) {
      this.currentStepPets = 1;
      this.editingPet = true;
      this.pet = pet;
      this.petDialog = true;
    },
    deletePet() {
      this.deleteDialog = false;
      this.newUser.pets.splice(this.newUser.pets.indexOf(this.selectedPet), 1);
      // localStorage.setItem("pets", JSON.stringify(this.pets));
    },
    requestEmailVerification() {
      if (this.updatingEmailVerified || this.emailVerifyDialog) {
        return;
      }

      this.pendingEmailVerified = !this.emailVerified;
      this.emailVerifyDialog = true;
      this.$nextTick(() => {
        this.emailSwitchKey += 1;
      });
    },
    cancelEmailVerification() {
      this.emailVerifyDialog = false;
      this.pendingEmailVerified = null;
      this.emailSwitchKey += 1;
    },
    async applyEmailVerification() {
      const nextValue = !!this.pendingEmailVerified;
      this.emailVerifyDialog = false;

      if (!this.newUser || !this.newUser.id) {
        this.emailSwitchKey += 1;
        this.pendingEmailVerified = null;
        this.promptMessage = "Could not find this account to update.";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      try {
        this.updatingEmailVerified = true;
        this.loading = true;

        await updateDoc(doc(db, "clients", this.newUser.id), {
          emailVerified: nextValue,
        });

        this.$set(this.newUser, "emailVerified", nextValue);

        if (this.originalUser) {
          this.$set(this.originalUser, "emailVerified", nextValue);
        }

        await logAction(
          "User Management",
          "Email Verification Update",
          this.loggedInUser.email,
          this.loggedInUser.email +
            " has marked the email for client account " +
            (this.newUser.email || "") +
            " as " +
            (nextValue ? "verified" : "not verified"),
        );

        this.promptMessage = nextValue
          ? "Email marked as verified."
          : "Email marked as not verified.";
        this.promptType = "success";
        this.promptDialog = true;
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.emailSwitchKey += 1;
        this.promptMessage =
          "An error occured while updating email verification, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      } finally {
        this.updatingEmailVerified = false;
        this.loading = false;
        this.pendingEmailVerified = null;
      }
    },
    async setUserStatus() {
      try {
        this.loading = true;
        const docRef = await setDoc(
          doc(db, "clients", this.originalUser.id),
          this.originalUser
        );
        this.loading = false;

        let res = await logAction(
          "User Management",
          "Status Update",
          this.loggedInUser.email,
          this.loggedInUser.email +
            " has updated the status of client account " +
            this.newUser.email +
            " to " +
            this.newUser.status
        );

        this.newUser.status = this.originalUser.status;

        this.promptMessage = "Successfully updated the doctor's status!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.promptDialog = false;
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log(error);
        this.promptMessage =
          "An error occured while updating the status, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    async refundUser() {
      this.refundDialog = false;

      let valid = this.$refs.refund.validate();

      if (!valid || this.refundAmount < 1) {
        this.promptMessage = "Please provide a valid amount";
        this.promptType = "error";
        this.promptDialog = true;
        return;
      }

      let newBalance = parseFloat(this.newUser.walletBalance);

      if (!newBalance) {
        newBalance = 0;
      }

      newBalance += parseInt(this.refundAmount);

      try {
        this.loading = true;
        const docRef = await updateDoc(doc(db, "clients", this.newUser.id), {
          walletBalance: newBalance
        });
        this.loading = false;

        let newTrans = {
          amount: this.refundAmount,
          createdAt: new Date(),
          description: "Refund",
          paymentMethod: "Paygate",
          paymentReference: "Refund",
          paymentType: "Refund",
          referenceId: "Refund",
          status: "completed",
          type: "Refund",
          userId: this.newUser.id
        };

        this.loading = true;
        const docRef2 = await addDoc(
          collection(db, "wallet_transactions"),
          newTrans
        );
        this.loading = false;

        this.promptMessage = "Successfully refunded client!";
        this.promptType = "success";
        this.promptDialog = true;

        setTimeout(() => {
          this.$router.go();
        }, 3000);
      } catch (error) {
        this.loading = false;
        console.log(error);

        this.promptMessage =
          "An error occured while refunding the client, please try again!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    }
  },
  computed: {
    loggedInUser() {
      return this.$store.state.user || {};
    },
    emailVerified() {
      return !!(this.newUser && this.newUser.emailVerified);
    }
  }
};
</script>

<style scoped>
.detail-field {
  padding: 14px 0;
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
}

.label {
  font-weight: 600;
  margin-right: 4px;
}

.saved-address {
  background: #f5f5f5;
  border-radius: 12px;
  font-size: 14px;
}

.update-btn {
  position: fixed;
  bottom: 56px;
  left: 0;
  right: 0;
  border-radius: 32px;
  margin: 0 auto;
  width: calc(100% - 32px);
  max-width: 440px;
  color: white;
  font-weight: 700;
  text-transform: uppercase;
  z-index: 200;
}

.register-card {
  background: #ffffff;
  padding: 32px;
  border-radius: 16px;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.steps {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.step {
  width: 24px;
  height: 4px;
  border-radius: 2px;
  margin: 0 4px;
}

.title {
  margin: 0 0 24px;
  font-size: 20px;
  font-weight: 500;
  color: #212121;
}

.field {
  margin-bottom: 16px;
}

.note {
  font-size: 12px;
  color: #9e9e9e;
  margin: -8px 0 24px;
}

.existing {
  font-size: 14px;
  color: #616161;
}

.existing a {
  color: #1976d2;
  text-decoration: none;
  margin-left: 4px;
  cursor: pointer;
}

.continue-btn--filled {
  background: #ff00ff;
  color: #ffffff;
  margin-bottom: 16px;
}

.google-btn {
  border-color: #1976d2;
  color: #1976d2;
  margin-bottom: 24px;
}

.continue-btn--outlined {
  border-color: #1976d2;
  color: #1976d2;
  margin-bottom: 16px;
}

.back-btn {
  color: #9e9e9e;
  margin-bottom: 24px;
}

.option-btn {
  margin-bottom: 16px;
  background: #f0f0f0;
  color: #212121;
  text-transform: none;
}

.option-btn.selected {
  background: #ff00ff;
  color: #ffffff;
}

.upload-row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.upload-label {
  flex: 1;
  text-align: left;
  font-size: 14px;
  color: #616161;
}

.upload-btn {
  text-transform: none;
  background: #1976d2;
  color: #ffffff;
}

.avatar-label {
  display: inline-block;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 2px dashed #ccc;
  overflow: hidden;
  cursor: pointer;
  text-align: center;
  line-height: 150px;
  color: #888;
  background: #f9f9f9;
}

.avatar-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  font-size: 14px;
  padding: 10px;
}

.email-verified-chip {
  position: absolute !important;
  top: 20px;
  right: 24px;
  z-index: 2;
  text-transform: none;
}

.selected {
  background-color: #e022d1 !important;
  color: white !important;
}

.selected h4 {
  color: white !important;
}

.selectedBlue {
  background-color: #4390c0 !important;
  color: white !important;
}
</style>